import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDailyCardPendingCount } from '../RTK/orders/GetAllOrders';
import notificationService from '../utils/notificationService';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { dailyCardPendingCount } = useSelector((state) => state.orders);
  const [previousCount, setPreviousCount] = useState(0);
  const [soundEnabled, setSoundEnabled] = useState(
    () => notificationService.getSoundPreference()
  );

  // ✅ استخدام ref لضمان إشعار واحد فقط
  const hasNotifiedRef = useRef(false);
  const lastNotificationTimeRef = useRef(0);
  const isInitializedRef = useRef(false);

  // ✅ جلب عدد الطلبات المعلقة من Daily Card
  useEffect(() => {
    const fetchCount = () => {
      dispatch(fetchDailyCardPendingCount());
    };

    fetchCount();

    // ✅ تحديث تلقائي كل 5 ثواني
    const intervalId = setInterval(fetchCount, 5000);

    return () => clearInterval(intervalId);
  }, [dispatch]);

  // ✅ مراقبة التغييرات في العدد وإرسال إشعار واحد فقط
  useEffect(() => {
    // ✅ تخطي أول render
    if (!isInitializedRef.current) {
      isInitializedRef.current = true;
      setPreviousCount(dailyCardPendingCount);
      return;
    }

    const now = Date.now();
    const timeSinceLastNotification = now - lastNotificationTimeRef.current;
    
    // ✅ التحقق من زيادة العدد وإرسال إشعار واحد فقط
    if (
      soundEnabled &&
      dailyCardPendingCount > previousCount &&
      previousCount > 0 &&
      timeSinceLastNotification > 3000 &&
      !hasNotifiedRef.current
    ) {
      hasNotifiedRef.current = true;
      lastNotificationTimeRef.current = now;
      
      // ✅ إرسال إشعار واحد فقط
      notificationService.notify("🔔 Daily Card! طلب جديد من", true);
      
      // ✅ إعادة تعيين بعد 5 ثواني
      setTimeout(() => {
        hasNotifiedRef.current = false;
      }, 5000);
    }
    
    setPreviousCount(dailyCardPendingCount);
  }, [dailyCardPendingCount, soundEnabled, previousCount]);

  // ✅ تفعيل/إيقاف الصوت
  const toggleSound = () => {
    const newState = notificationService.toggleSound();
    setSoundEnabled(newState);
    return newState;
  };

  return (
    <NotificationContext.Provider
      value={{
        dailyCardPendingCount,
        soundEnabled,
        toggleSound,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

// ✅ Hook مبسط
export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within NotificationProvider');
  }
  return context;
};